var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28207",
    "data-name": "Group 28207",
    transform: "translate(0 -0.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    transform: "translate(0 0.234)",
    fill: "none",
    stroke: "#fc3",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37809",
    "data-name": "Path 37809",
    d: "M1.727-16.206v6.487H3.519v-7.057ZM1.536-7.632a1.094,1.094,0,0,0,2.188,0A1.094,1.094,0,0,0,1.536-7.632Z",
    transform: "translate(6.487 20.782)",
    fill: "#fc3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.fad10b1eb281948857b731f5bed68c8d.svg";
export { ForwardRef as ReactComponent };